import KValidationProvider from "./KValidationProvider";
import { VInput } from "vuetify/lib";

export default {
	name: "KValidatableInput",

	extends: VInput,

	mixins: [ KValidationProvider ],

	inheritAttrs: false,

	methods: {
		genDefaultSlot() {
			return [
				this.genLabel(),
				this.genValidationProvider()
			];
		}
	}
};
